import DataRoomNdaBulkActions from './DataRoomNdaBulkActions.component';

export default DataRoomNdaBulkActions;
